import { AccordionItem } from 'library/components/controls/accordion/AccordionItem';

import { ReleaseNoteDevAccordionContent } from './ReleaseNoteDevAccordionContent';
import ReleaseNoteHeader from './ReleaseNoteHeader';
import { ReleaseNoteListProps } from './types';

export const ReleaseNoteDevAccordion = ({
	releaseNote: releaseNoteList,
}: ReleaseNoteListProps) => {
	const { id } = releaseNoteList;

	return (
		<AccordionItem
			accordionName={id.toString()}
			HeaderComponent={
				<ReleaseNoteHeader releaseNote={releaseNoteList} />
			}
			key={id}>
			<ReleaseNoteDevAccordionContent id={releaseNoteList.id} />
		</AccordionItem>
	);
};
